/**
 * @file        src/lib/walletTypes.js
 * @description Human wording for the `wallet_transactions.type` and
 *              `wallet_lots.source_type` enums (022_wallet.sql). The company
 *              wallet ledger and the Reports Wallet tab printed the raw column
 *              value — "booking_debit", "admin_credit" — while the retail wallet
 *              screen carried its own private map of the same enum. One map, so
 *              a value cannot read two ways on two screens, and so a NEW enum
 *              member is humanised ("credit_reversal" -> "Credit reversal")
 *              rather than reaching an admin as a database identifier.
 * @author      Kinetika Labs
 * @created     2026-09-24
 */

// Admin-facing wording. The ledger's own Debit/Credit columns carry the
// direction, so these name the EVENT, not the sign.
export const WALLET_TYPE_LABEL = {
  admin_credit: 'Admin credit',
  recharge: 'Recharge',
  booking_debit: 'Booking',
  refund: 'Refund',
  expiry: 'Expired',
  reversal: 'Reversal',
  adjustment: 'Adjustment',
};

/**
 * @param {string} value  a wallet transaction type / lot source_type
 * @returns {string} the label, or the value title-cased if it is unmapped
 */
export function walletTypeLabel(value) {
  if (!value) return '—';
  if (WALLET_TYPE_LABEL[value]) return WALLET_TYPE_LABEL[value];
  const words = String(value).replace(/_/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : '—';
}
